import { colors } from '@lmc/common/constants'
import React, { type ReactElement } from 'react'
import LogSummary from '../../../../atoms/LogSummary'
import { getLabel, getSubtext } from './utils'

export type LogCellProps = {
  log: {
    category?: { icon?: string; color?: string }
    deleted?: boolean
    description?: string
    item?: { icon?: string; color?: string }
    title?: string
  }
  onSelect?: () => void
  role?: string
  style?: object
}

export default function LogCell({
  log,
  log: { category, deleted, description, item, title },
  onSelect,
  role,
  style
}: LogCellProps): ReactElement {
  return (
    <LogSummary
      color={item?.color || category?.color || colors.darkblue}
      description={description}
      icon={item?.icon || category?.icon || ''}
      label={getLabel(log)}
      onPress={(role === 'carehome-admin' && onSelect) || undefined}
      removedLog={deleted}
      style={{ ...styles.log, ...style }}
      subtext={getSubtext(log)}
      title={title}
    />
  )
}

const styles = {
  log: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    lineHeight: 1.4
  }
}
